import React, { useContext, useState } from "react"
import BentoSelectedContent from "./BentoSelectedContent"
import Loader from "../ui/loader"
import { Button } from "../ui/button"
import { CoachPrivateProfileContext } from "../../pages/manage-business/profile/context/coachPrivateProfileContext"
import { SvgEdit } from "../icons"
import { useLocation, matchPath } from "react-router-dom"

interface Props {
  endpointSlug: string
  setEditBento?: (v: boolean) => void
  coachData: any
  coachColor: any
  setBentoBoxSelection?: (n: number) => void
  editBento?: boolean
  setActiveTab?: any
}

type BoxType = "quote" | "video" | "blog" | "testimonial" | "image"

export default function BentoBoxThree({
  setEditBento,
  coachData,
  coachColor,
  setBentoBoxSelection,
  endpointSlug,
  setActiveTab,
}: Props) {
  const [boxType, setBoxType] = useState<BoxType>()
  const { loadingBento } = useContext(CoachPrivateProfileContext)

  const { pathname } = useLocation()

  const match = matchPath(
    { path: "/find-a-coach/:slug", end: true },
    pathname
  )

  const isPublicProfileView =
    !!match && match.params?.slug?.toLowerCase() === (endpointSlug || "").toLowerCase()

  return loadingBento ? (
    <Loader />
  ) : (
    <div className="relative h-[460px] w-[300px] group">
      <BentoSelectedContent
        coachData={coachData}
        endpointSlug={endpointSlug}
        coachColor={coachColor}
        bentoBoxNumber={"three"}
        setBoxType={setBoxType}
        isPublicProfileView={isPublicProfileView}
        boxType={boxType}
        setActiveTab={setActiveTab}
      />

      {!isPublicProfileView && (
        <Button
          className="absolute right-2 top-2 z-[20] invisible group-hover:visible"
          variant="utility"
          size="sm"
          onClick={() => {
          setEditBento?.(true)
          setBentoBoxSelection?.(3)
        }}
        >
          <SvgEdit />
          Edit
        </Button>
      )}
    </div>
  )
}